/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Showcase_Self_Hosted_DescriptionInputs */



/**
* | output |
* | --- |
* | "A model your organization runs on its own infrastructure." |
*
* @param {Model_Showcase_Self_Hosted_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_showcase_self_hosted_description = /** @type {((inputs?: Model_Showcase_Self_Hosted_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Showcase_Self_Hosted_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein Modell, das Ihre Organisation auf eigener Infrastruktur betreibt.")
	return /** @type {LocalizedString} */ ("A model your organization runs on its own infrastructure.")
});